import React from "react";
import { Box } from "@mui/material";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import SectionSwitcher from "../../components/ProcurementDashboard/SectionSwitcher";
import ContractsSection from "../../components/ProcurementDashboard/ContractsSection";
import SourcingSection from "../../components/ProcurementDashboard/SourcingSection";
import SuppliersSection from "../../components/ProcurementDashboard/SuppliersSection";
import contractsIcon from "../../assets/images/contracts.svg";
import sourcingIcon from "../../assets/images/sourcing.svg";
import suppliersIcon from "../../assets/images/suppliers.svg";
import procurementIcon from "../../assets/images/performanceImg.svg";
import styles from "./ProcurementDashboard.module.scss";

const ProcurementDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveTab = () => {
    const path = location.pathname;
    if (path.includes("/contracts-management")) return 0;
    if (path.includes("/sourcing-analytics")) return 1;
    if (path.includes("/supplier-management")) return 2;
    return 0;
  };

  const sections = [
    { label: "Contracts", value: 0, icon: contractsIcon },
    { label: "Sourcing", value: 1, icon: sourcingIcon },
    { label: "Suppliers", value: 2, icon: procurementIcon },
  ];

  const handleSectionChange = (newValue: number) => {
    const routes = [
      "/procurement-dashboard/contracts-management",
      "/procurement-dashboard/sourcing-analytics",
      "/procurement-dashboard/supplier-management",
    ];
    navigate(routes[newValue]);
  };

  return (
    <Box className={styles.landingContainer}>
      <Box className={styles.contentWrapper}>
        <Sidebar activeNav="dashboard" />
        <Box className={styles.mainContent}>
          <Box className={styles.sectionNavigation}>
            <SectionSwitcher
              sections={sections}
              activeSection={getActiveTab()}
              onChange={handleSectionChange}
            />
          </Box>

          <Box className={styles.dashboardContent}>
            <Routes>
              <Route
                index
                element={<Navigate to="contracts-management" replace />}
              />
              <Route
                path="contracts-management"
                element={<ContractsSection />}
              />
              <Route path="sourcing-analytics" element={<SourcingSection />} />
              <Route
                path="supplier-management"
                element={<SuppliersSection />}
              />
            </Routes>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ProcurementDashboard;
